import { Observable, throwError } from 'rxjs';
import 'rxjs/add/operator/do';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../../services/auth.service';
import {catchError} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
// ----------------

const NO_TOKEN = [
    '/oauth/token',
    // '/util/tipo',
    // '/util/area'
];
@Injectable({
    providedIn: 'root'
})
export class RequestInterceptorService implements HttpInterceptor {
    constructor(
        private _authService: AuthService,
        private route : Router,
        private activatedRoute: ActivatedRoute
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        request = request.clone({
          params: request.params.set('d', new Date().getTime().toString())
        })

        const requiresToken = !NO_TOKEN.some(url => request.url.includes(url));

        if (requiresToken && !this._authService.tokenExpired()) {
            const token = this._authService.getUser();
            if (token) {
              request = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${token}`
                }
              });
            }
          } else if (this._authService.tokenExpired()) {
            // If the token is expired, logout and navigate to home
            this._authService.cerrar();
            if (window.location.href.includes('consultarCUO')) {
              this.route.navigate(['/']);
            }
          }
      
          return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
              if (error.status === 403) {
                this._authService.logout();
              }
              return throwError(error);
            })
          );


        // if (this._authService.tokenExpired()) {
        //     this._authService.logout();
        //     if (!window.location.href.includes('consultarCUO')) {
        //       this.route.navigate(['/']);
        //     }
        // }

        // return next.handle(request).do(e => {
        //     if (e['status'] == 403) {
        //        this._authService.logout()
        //     }
        // })
    }
}
